import React, { useEffect, useMemo, useState } from "react";
import "./EdgeFlowers.css";
import { buildEdgeFlowers } from "./edgeFlowers";
import FlowerField from "./FlowerField";

/**
 * EdgeFlowers — a fixed, full-viewport cut-paper wildflower frame behind the game
 * content. Flowers cling to the left/right margins, densest in the bottom corners
 * (see edgeFlowers.js). Sits at z-index:-1 inside #root, so it shows only in the
 * empty side margins (never over the game cards) and never catches clicks.
 * Regenerates on resize (rAF-debounced). Memoized: it takes no props, so the
 * host game screens' frequent state changes never re-render it.
 */
function EdgeFlowers() {
  const [size, setSize] = useState(() => ({
    w: window.innerWidth,
    h: window.innerHeight,
  }));

  useEffect(() => {
    let raf = 0;
    const onResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() =>
        setSize({ w: window.innerWidth, h: window.innerHeight })
      );
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      cancelAnimationFrame(raf);
    };
  }, []);

  const field = useMemo(
    () => buildEdgeFlowers({ width: size.w, height: size.h }),
    [size.w, size.h]
  );

  const { vw, vh, templates, layers } = field;
  return (
    <svg
      className="edge-flowers"
      viewBox={`0 0 ${vw} ${vh}`}
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <FlowerField templates={templates} layers={layers} idPrefix="edge-flower" />
    </svg>
  );
}

export default React.memo(EdgeFlowers);
